module.exports = __webpack_public_path__ + "img/logotext.8e099b30.png";